import {Component, OnInit, AfterViewInit, OnDestroy} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {DomSanitizer, SafeResourceUrl} from "@angular/platform-browser";

@Component({
  selector: 'app-iframe',
  templateUrl: './iframe.component.html',
  styleUrls: ['./iframe.component.scss']
})
export class IFrameComponent implements OnInit, AfterViewInit, OnDestroy {
  iframeSrc: SafeResourceUrl = '';
  selectedComponent: string = 'search-start-v2';
  
  // Size controls
  containerWidth: string = '100vw';
  containerHeight: string = '100vh';
  widthValue: string = '100';
  heightValue: string = '100';
  widthUnit: string = 'vw';
  heightUnit: string = 'vh';
  
  // Available components for testing
  availableComponents = [
    { value: 'search-start-v2', label: 'Search Start V2' },
    { value: 'search-results-v2', label: 'Search Results V2' },
    // { value: 'carefindr-ai', label: 'CareFindr AI' },
  ];
  
  // Available units
  availableUnits = ['px', '%', 'vw', 'vh'];

  constructor(
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer
  ) {}

  ngOnInit(): void {
    // Get component from query params or use default
    this.route.queryParams.subscribe(params => {
      this.selectedComponent = params['component'] || 'search-start-v2';
      this.updateIframeSrc();
    });

	// puts overflow-y hidden on the internal html of Carefindr when iframed
	const iframeList = document.getElementsByClassName("iframe-tester");
	console.log(iframeList)
	let iframe = iframeList[0] as HTMLIFrameElement;
	iframe.addEventListener("load", () => {
		const iframeDoc = iframe.contentDocument || iframe.contentWindow?.document;
		if (iframeDoc) {
			const html = iframeDoc.querySelector("html");
			if (html) {
				html.style.overflowY = "hidden";
			}
		}
	});
  }

  ngAfterViewInit(): void {
    // Initialize container size after view is ready
    this.updateContainerSize();
    
    // Apply global classes to prevent scrollbars
    this.enableIframeTesting();
  }

  ngOnDestroy(): void {
    // Remove global classes when component is destroyed
    this.disableIframeTesting();
  }

  private enableIframeTesting(): void {
    // Add classes to html and body to prevent scrollbars
    const html = document.documentElement;
    const body = document.body;
    
    if (html) {
      html.classList.add('iframe-testing-mode');
      html.style.overflow = 'hidden';
      html.style.width = '100vw';
      html.style.height = '100vh';
      html.style.margin = '0';
      html.style.padding = '0';
    }
    
    if (body) {
      body.classList.add('iframe-testing-mode');
      body.style.overflow = 'hidden';
      body.style.width = '100vw';
      body.style.height = '100vh';
      body.style.margin = '0';
      body.style.padding = '0';
    }
  }

  private disableIframeTesting(): void {
    // Remove classes and styles when leaving
    const html = document.documentElement;
    const body = document.body;
    
    if (html) {
      html.classList.remove('iframe-testing-mode');
      html.style.overflow = '';
      html.style.width = '';
      html.style.height = '';
      html.style.margin = '';
      html.style.padding = '';
    }
    
    if (body) {
      body.classList.remove('iframe-testing-mode');
      body.style.overflow = '';
      body.style.width = '';
      body.style.height = '';
      body.style.margin = '';
      body.style.padding = '';
    }
  }

  onComponentChange(): void {
    this.updateIframeSrc();
  }

  onSizeChange(): void {
    this.updateContainerSize();
  }

  onWidthUnitChange(): void {
    this.updateContainerSize();
  }

  onHeightUnitChange(): void {
    this.updateContainerSize();
  }

  resetToFullSize(): void {
    this.widthValue = '100';
    this.heightValue = '100';
    this.widthUnit = 'vw';
    this.heightUnit = 'vh';
    this.updateContainerSize();
  }

  private updateIframeSrc(): void {
    const baseUrl = window.location.origin;
    const testUrl = `${baseUrl}/test/${this.selectedComponent}`;
    this.iframeSrc = this.sanitizer.bypassSecurityTrustResourceUrl(testUrl);
  }

  private updateContainerSize(): void {
    // Validate and sanitize input values
    const width = Math.max(0, parseFloat(this.widthValue) || 0);
    const height = Math.max(0, parseFloat(this.heightValue) || 0);
    
    // Update the size strings
    this.containerWidth = `${width}${this.widthUnit}`;
    this.containerHeight = `${height}${this.heightUnit}`;
    
    // Apply the size to the container element
    const container = document.querySelector('.iframe-container') as HTMLElement;
    if (container) {
      container.style.width = this.containerWidth;
      container.style.height = this.containerHeight;
      // Always ensure max dimensions don't exceed viewport
      container.style.maxWidth = '100vw';
      container.style.maxHeight = '100vh';
    }
  }

  getContainerStyles(): { [key: string]: string } {
    return {
      'width': this.containerWidth,
      'height': this.containerHeight,
      'max-width': '100vw', // Always limit to viewport
      'max-height': '100vh' // Always limit to viewport
    };
  }
}